import _defineProperty from "/home/vsts/work/r1/a/artifacts/source-code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { buildBindable } from '@monofe/di';
import { TYPES, bindAssetFetcher, injectAssetFetcher, unbindAssetFetcher } from '@monofe/ui-workspace/common/asset';
import DATA_IMAGE from './asset.image';
const WEIGHTING_ASPECT_RATIO = 0.5;
/* 50% */

const WEIGHTING_SIZE = 0.25;
/* 25% (width or height) */

/** The maths checks out - Alex */

function _weightings(valuesIn, targetValue, weightGenerator) {
  const weightingsAll = valuesIn.map(value => weightGenerator(value));
  const weightingsMin = Math.min(...weightingsAll);
  const weightingsMax = Math.max(...weightingsAll);
  const weightingsDelta = weightingsMax - weightingsMin;
  /* Take all of the weight values and place it within the range of possible values, 
     such that weightingsNormalized contains values between 0->1 only, where 0=targetValue & 1=further value away received */

  const weightingsNormalized = weightingsAll.map(weight => Math.abs(weight - targetValue) / weightingsDelta);
  return {
    minValue: weightingsMin,
    maxValue: weightingsMax,
    weightings: weightingsAll,
    weightingsNormalized: weightingsNormalized
  };
}

function _closestImage(target, allImages) {
  var _weightedImages$shift;

  /* For each image generate a weighting value, where 0=same as target & 1=furthest value away */
  const weightingsAR = _weightings(allImages, target.width / target.height, image => image.width / image.height);

  const weightingsWidth = _weightings(allImages, target.width, image => image.width);

  const weightingsHeight = _weightings(allImages, target.height, image => image.height);

  const weightedImages = allImages.map((image, index) => {
    const aspectRatio = weightingsAR.weightingsNormalized[index];
    const width = weightingsWidth.weightingsNormalized[index];
    const height = weightingsHeight.weightingsNormalized[index];

    if (aspectRatio === undefined || width === undefined || height === undefined) {
      throw new Error("Weightings arrays are not the same length. This shouldn't happen");
    }

    return _objectSpread(_objectSpread({}, image), {}, {
      weight:
      /* Take the weightings generated above & generate an overall weight value, 
      where the aspect-ratio takes priority over image size */
      aspectRatio * WEIGHTING_ASPECT_RATIO + width * WEIGHTING_SIZE + height * WEIGHTING_SIZE
    });
  });
  /* Sort by smallest weight first */

  weightedImages.sort((previous, next) => previous.weight - next.weight);
  /* & pick it out, this image is the closest to #target above */

  const asset = (_weightedImages$shift = weightedImages.shift()) !== null && _weightedImages$shift !== void 0 ? _weightedImages$shift : allImages.at(0);

  if (!asset) {
    throw new Error('Cannot find closest image, none provided!');
  }

  return asset;
}

function _imageAsset(group, name) {
  return DATA_IMAGE[group][name];
}

function _imageAssetGroup(group) {
  return Object.values(DATA_IMAGE[group]);
}

function _imageAssetGroupClosestMatch(group, targetWidth, targetHeight) {
  const allValues = Object.values(DATA_IMAGE[group]);

  const image = _closestImage({
    width: targetWidth,
    height: targetHeight
  }, allValues);

  return image;
}

function _build() {
  return {
    imageAsset: _imageAsset,
    imageAssetGroup: _imageAssetGroup,
    imageAssetGroupClosestMatch: _imageAssetGroupClosestMatch
  };
}

export default buildBindable({
  id: TYPES.IAssetFetcher,
  dependencies: [],
  bind: bindAssetFetcher,
  remove: unbindAssetFetcher,
  inject: injectAssetFetcher,
  build: () => Promise.resolve(_build())
});